<template>
    <div class="invoice">
        <el-container>
            <el-main ref="main">
                <div class="container">
                    <div class="titleBox">
                        <div>发票信息：</div>
                    </div>
                    <el-form class="dataFormBox" :inline="true" :model="dataForm">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票代码：">
                                    <el-input v-model="dataForm.billCode" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票号码：">
                                    <el-input v-model="dataForm.billNumber" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="开票日期：">
                                    <el-input v-model="dataForm.invoiceDate" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="税额：">
                                    <el-input v-model="dataForm.tax" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="可抵扣税额：">
                                    <el-input v-model="dataForm.amountDeduct" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="销方名称：">
                                    <el-input v-model="dataForm.billHead" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="销方税号：">
                                    <el-input v-model="dataForm.taxPayerCode" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票金额：">
                                    <el-input v-model="dataForm.amount" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="用途：">
                                    <el-input v-model="dataForm.usage" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票类型：">
                                    <el-input v-model="dataForm.billTypeShow" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </el-form>

                    <div class="titleBox">
                        <div>认领信息：</div>
                    </div>
                    <el-form>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="是否认领：">
                                    <el-input v-model="dataForm.isClaimedShow" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="金额是否匹配：">
                                    <el-input v-model="dataForm.isAmountMatchShow" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="项目部：">
                                    <el-input v-model="dataForm.deptName" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="项目名称：">
                                    <el-input v-model="dataForm.projectName" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="分项合同：">
                                    <el-input v-model="dataForm.subContractName" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="分项合同编号：">
                                    <el-input v-model="dataForm.subContractSerial" :readonly="true" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </el-main>
            <el-footer class="container">
                <div class="btnMid">
                    <el-button type="info" @click="reset()">关闭</el-button>
                </div>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import  {
        getClaimDetailService,
    } from '@/services/invoiceServices'
    export default {
        name: "invoiceClaimDetail",
        data(){
            return {
                dataForm:{
                    billHead: '',
                    taxPayerCode: '',
                    billNumber: '',
                    billCode: '',
                    amountWithoutTax: '',
                    tax: '',
                    taxRateShow: '',
                    amount: '',
                    billInvoiceTypeShow: '',
                    isClaimedShow: '',
                    isAmountMatchShow: '',
                },
                id: '',
            }
        },
        methods:{
            onActive(menuCode) {
                this.id = this.tabRouteParam.id;
                this.getIncomeDetail();
            },
            /**
             * 获取申请发票详情
             * */
            getIncomeDetail(){
                let paramsData = {
                    id: this.id
                }
                getClaimDetailService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.dataForm = res.data;
                        this.dataForm.currentUserName = res.data.approveUserName;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                this.bus.$emit("tabClose", "invoiceClaimDetail");
                this.bus.$emit("navMenuChange", {
                    routeId: "invoiceClaim"
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px 0;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
        }
        .containerBox{
            width: 1100px;
        }
    }
    /deep/.el-container .el-main{
        height: 100%;
    }
    /deep/.el-textarea{
        width: 600px;
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    /deep/.upload-demo{
        display: flex;
        align-items: center;
        .el-icon-close:before{
            color: #000000;
        }
        .el-upload-list__item{
            margin-top: 0px;
            margin-left: 10px;
        }
        .el-upload-list__item-name{
            margin-right: 0px;
            width: 75px;
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .dataFormBox{
        margin:30px 20px;
    }
    .btnMid {
        width: 300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
    }
    .addBtn {
        width: 30px;
        height: 30px;
    }
</style>
